const initialState = {
    corporatePermissions: {},
    corporateLists: [],
    corporateHighlightedRecord: null,
    corporateDetails: [],
    corporateViewDetails: [],
    corporateStatus: [],
    changedCorporateStatus: [],
    corporateID: null,
    loadingCorporate: false,
    loadingCorporateSocial: false,
    loadingCorporateVerification: false,
    loadingCorporateCompanyDetail: false,
    loadingCorporateAlert: false,
    loadingCorporateGrievance: false,
    loadingBlacklistCorporate: false,
    errorsCorporate: {},
    errorsCorporateSocial: {},
    errorsCorporateVerification: {},
    errorsCorporateCompanyDetail: {},
    errorsCorporateAlert: {},
    errorsCorporateGrievance: {},
    errorsBlacklistCorporate: {},
};

const corporateReducerView = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_CORPORATE_PENDING_VIEW":
        case "UPDATE_CORPORATE_PENDING_VIEW":
        case "GET_CORPORATEVIEWBYID_PENDING_VIEW":
            return { ...state, loadingCorporate: true };
        case "UPDATE_CORPORATE_SOCIALMEDIA_PENDING_VIEW":
            return { ...state, loadingCorporateSocial: true };
        case "CORPORATE_VERIFICATION_PENDING_VIEW":
            return { ...state, loadingCorporateVerification: true };
        case "CORPORATE_COMAPNYDETAILS_PENDING_VIEW":
            return { ...state, loadingCorporateCompanyDetail: true };
        case "CORPORATE_ALERT_PENDING_VIEW":
            return { ...state, loadingCorporateAlert: true };
        case "CORPORATE_GRIEVANCE_PENDING_VIEW":
            return { ...state, loadingCorporateGrievance: true };
        case "CORPORATE_BLACKLIST_PENDING_VIEW":
            return { ...state, loadingBlacklistCorporate: true };

        case "ADD_CORPORATE_FULFILLED_VIEW":
            return {
                ...state,
                loadingCorporate: false,
                changedCorporateStatus: action.payload,
                corporateID: action.payload?.data?.id,
            };

        case "UPDATE_CORPORATE_FULFILLED_VIEW":
            return {
                ...state,
                loadingCorporate: false,
                changedCorporateStatus: action.payload,
            };

        case "GET_CORPORATEVIEWBYID_FULFILLED_VIEW":
            return {
                ...state,
                loadingCorporate: false,
                corporateViewDetails: action.payload,
            };

        case "ADD_CORPORATE_REJECTED_VIEW":
        case "UPDATE_CORPORATE_REJECTED_VIEW":
        case "GET_CORPORATEVIEWBYID_REJECTED_VIEW":
            return {
                ...state,
                loadingCorporate: false,
                errorsCorporate: action.payload,
            };

        case "UPDATE_CORPORATE_SOCIALMEDIA_FULFILLED_VIEW":
            return {
                ...state,
                loadingCorporateSocial: false,
                changedCorporateStatus: action.payload,
                errorsCorporateSocial: {},
            };
        case "CORPORATE_VERIFICATION_FULFILLED_VIEW":
            return {
                ...state,
                loadingCorporateVerification: false,
                changedCorporateStatus: action.payload,
                errorsCorporateVerification: {},
            };
        case "CORPORATE_COMAPNYDETAILS_FULFILLED_VIEW":
            return {
                ...state,
                loadingCorporateCompanyDetail: false,
                changedCorporateStatus: action.payload,
                errorsCorporateCompanyDetail: {},
            };
        case "CORPORATE_ALERT_FULFILLED_VIEW":
            return {
                ...state,
                loadingCorporateAlert: false,
                changedCorporateStatus: action.payload,
                errorsCorporateAlert: {},
            };
        case "CORPORATE_GRIEVANCE_FULFILLED_VIEW":
            return {
                ...state,
                loadingCorporateGrievance: false,
                changedCorporateStatus: action.payload,
                errorsCorporateGrievance: {},
            };
        case "CORPORATE_BLACKLIST_FULFILLED_VIEW":
            return {
                ...state,
                loadingBlacklistCorporate: false,
                changedCorporateStatus: action.payload,
                errorsBlacklistCorporate: {},
            };
        case "UPDATE_CORPORATE_SOCIALMEDIA_REJECTED_VIEW":
            return {
                ...state,
                loadingCorporateSocial: false,
                errorsCorporateSocial: action.payload,
            };
        case "CORPORATE_VERIFICATION_REJECTED_VIEW":
            return {
                ...state,
                loadingCorporateVerification: false,
                errorsCorporateVerification: action.payload,
            };
        case "CORPORATE_COMAPNYDETAILS_REJECTED_VIEW":
            return {
                ...state,
                loadingCorporateCompanyDetail: false,
                changedCorporateStatus: [],
                errorsCorporateCompanyDetail: action.payload,
            };
        case "CORPORATE_ALERT_REJECTED_VIEW":
            return {
                ...state,
                loadingCorporateAlert: false,
                changedCorporateStatus: [],
                errorsCorporateAlert: action.payload,
            };
        case "CORPORATE_GRIEVANCE_REJECTED_VIEW":
            return {
                ...state,
                loadingCorporateGrievance: false,
                changedCorporateStatus: [],
                errorsCorporateGrievance: action.payload,
            };
        case "CORPORATE_BLACKLIST_REJECTED_VIEW":
            return {
                ...state,
                loadingBlacklistCorporate: false,
                changedCorporateStatus: [],
                errorsBlacklistCorporate: action.payload,
            };
        case "RESET_DELETE_CORPORATE_STATUS_VIEW":
            return {
                ...state,
                loadingCorporate: false,
                loadingCorporateCompanyDetail: false,
                changedCorporateStatus: [],
                errorsCorporate: {},
                errorsCorporateSocial: {},
                errorsCorporateVerification: {},
                errorsCorporateCompanyDetail: {},
                errorsCorporateAlert: {},
                errorsCorporateGrievance: {},
                errorsBlacklistCorporate: {},
            };

        case "CLEAR_CORPORATE_DETAILS_VIEW":
        case "RESET_CORPORATE_STATE_VIEW":
            return {
                ...initialState,
            };

        default:
            return state;
    }
};

export default corporateReducerView;
